module.exports = __webpack_public_path__ + "static/media/3-2_Side_Attached_02.40343efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/3-2_Side_Attached_02.jpg
// module id = 1734
// module chunks = 0